/* eslint-disable */
/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import Typography from '../../../../components/common/Typography/index'
import Select from '../../../../components/common/Select/index'
import Button from '../../../../components/common/Button/index'
import MiniHeader from '../../../../components/layout/MiniHeader'
import ButtonCustom from '../../../../components/common/CustomButton/index'
import Card from '../../../../components/common/Card/index'
import LoadingIndicator from '../../../../components/state/LoadingIndicator'
import ErrorState from '../../../../components/state/ErrorState'
import useAppSelector from '../../../../state/redux/hooks/index'
import { fetchCustomers } from '../../../../state/redux/actions/customerActions'
import { fetchAgents } from '../../../../state/redux/actions/agentActions'
import { fetchProperties } from '../../../../state/redux/actions/propertyActions'
import { swipeWithoutAction, swipeWithAction } from '../../../../state/redux/actions/activityActions'
import {
  getInterestedProperties,
  getTrendingAnalytics,
  getMostViewedProperties,
  getSavedProperties,
  getDislikedProperties,
  getLikedProperties,
  getMessageCount,
  getHourlyPropertyViews,
  getPlatformRatingStatistics,
  // Agent Dashboard Analytics
  getCallVolume,
  getMessageCountAnalytics,
  getSalesTrends,
  getBookings,
  getRatings,
  getCommissionReturns,
  getTopBrokers,
  getTeamMembers,
  getMostViewedPropertiesAgent,
  getReviewCounts,
} from '../../../../features/analytics/services/analyticsApi'

import {
  fetchCallVolume,
  fetchMessageCountAnalytics,
  fetchMessageCount,
  fetchAdminTotalMessages,
  fetchAdminSavedItems,
  fetchSalesTrends,
  fetchBookings,
  fetchRatings,
  fetchCommissionReturns,
  fetchTopBrokers,
  fetchBrokers,
  fetchTeamMembers,
  fetchMostViewedPropertiesAgent as fetchMostViewedPropertiesAgentThunk,
  fetchReviewCounts,
  fetchFilterSearches,
  fetchTotalAppDownloads,
} from '../../../../state/redux/actions/analyticsAction'
import { RiAppleFill } from 'react-icons/ri'
import { IoIosArrowDown } from 'react-icons/io'
import { MdOutlineVerified, MdClose } from 'react-icons/md'
import GooglePlayIcon from '../../../../components/common/Icons/GooglePlayIcon'
import TotalSales from '../../../../components/charts/TotalSales'
import TotalSaved from '../../../../components/charts/TotalSaved'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Backdrop from '../../../../components/common/Backdrop/Backdrop'
import ViewingsBar from '../../../../components/charts/ViewingsBar'
import MessageCount from '../../../../components/charts/MessageCount'
import MessageCountAgent from '../../../../components/charts/MessageCountAgent'
import CallCount from '../../../../components/charts/CallCount'
import RatingChart from '../../../../components/charts/RatingChart'
import ReviewChart from '../../../../components/charts/ReviewCharts'
import SurveyReviewChart from '../../../../components/charts/SurveyChart'
import CommissionReturnsChart from '../../../../components/charts/CommissionReturnsChart'
import { setMiniHeaderState } from '../../../../state/redux/slices/uiSlice'
import ViewingsBarCustom from '../../../../components/charts/ViewsBarCustom'
// CardActionArea not used; removed

const filterOptions = [
  { value: 'all', label: 'All' },
  { value: 'saved', label: 'Saved Properties' },
  { value: 'review', label: 'Reviews' },
  { value: 'callCount', label: 'Calls' },
  { value: 'broker', label: 'Broker' },
  { value: 'messages', label: 'Message' },
]

const tabs = [
  { id: 'both', label: 'Both' },
  { id: 'customer', label: 'Customers' },
  { id: 'agent', label: 'Agents' },
]

// GridTable removed; using custom styled filter table

const Overview = () => {
  const [activeTab, setActiveTab] = useState('customer')
  const [filterValue, setFilterValue] = useState('all')
  const location = useLocation()
  const navigate = useNavigate()
  const [showToast, setShowToast] = useState(false)
  const pathname = location.pathname.replace(/^\/+|\/+$/g, '')
  const [swipeActionData, setSwipeActionData] = useState(null)
  const [swipeWithoutActionData, setSwipeWithoutActionData] = useState(null)
  const { agents, loading: agentsLoading, error: agentsError } = useAppSelector(state => state.agent)
  const { customers, loading: customersLoading, error: customersError } = useAppSelector(state => state.customer)
  const { properties, loading: propertiesLoading, error: propertiesError } = useAppSelector(state => state.property)
  const { activities, loading: activitiesLoading, error: activitiesError } = useAppSelector(state => state.activity)

  const {
    interestedProperties,
    trendingAnalytics,
    mostViewedProperties,
    savedProperties,
    dislikedProperties,
    likedProperties,
    messageCount,
    hourlyPropertyViews,
    platformRatingStatistics,
    // Agent Dashboard Analytics
    callVolume,
    messageCountAnalytics,
    salesTrends,
    bookings,
    ratings,
    commissionReturns,
    topBrokers,
    teamMembers,
    brokers,
    mostViewedPropertiesAgent,
    reviewCounts,
    adminTotalMessages,
    adminSavedItems,
    filterSearches,
    totalAppDownloads,
    loading: analyticsLoading,
    error: analyticsError,
  } = useAppSelector(state => state.analytics)

  const loading = agentsLoading || customersLoading || propertiesLoading || analyticsLoading
  const error = agentsError || customersError || propertiesError || analyticsError
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchAgents())
    dispatch(fetchCustomers())
    dispatch(fetchProperties())
    dispatch(swipeWithoutAction()).then((result) => {
      if (result.payload) {
        setSwipeWithoutActionData(result.payload)
      }
    })
    dispatch(swipeWithAction()).then((result) => {
      if (result.payload) {
        setSwipeActionData(result.payload)
      }
    })
    dispatch(getInterestedProperties())
    dispatch(getTrendingAnalytics())
    dispatch(getMostViewedProperties({ limit: 10 }))
    dispatch(getSavedProperties())
    dispatch(getDislikedProperties())
    // use analytics thunk for message count (admin analytics shape)
    dispatch(fetchMessageCountAnalytics())
    dispatch(getHourlyPropertyViews())
    dispatch(getLikedProperties())
    dispatch(getPlatformRatingStatistics())
    dispatch(fetchFilterSearches())
    dispatch(fetchTotalAppDownloads())

    // Agent Dashboard Analytics - only fetch when agent tab is active
    if (activeTab === 'agent' || activeTab === 'both') {
      // dispatch service-based API calls (legacy) for compatibility
      dispatch(getCallVolume())
      dispatch(getMessageCountAnalytics())
      dispatch(getSalesTrends())
      dispatch(getBookings())
      dispatch(getRatings())
      dispatch(getCommissionReturns())
      dispatch(getTopBrokers())
      dispatch(getTeamMembers())
      dispatch(getReviewCounts())

      // dispatch new Redux async thunks so data is stored in analytics slice
      dispatch(fetchCallVolume())
      dispatch(fetchMessageCountAnalytics())
      dispatch(fetchSalesTrends())
      dispatch(fetchBookings())
      dispatch(fetchRatings())
      dispatch(fetchCommissionReturns())
      dispatch(fetchTopBrokers())
      dispatch(fetchTeamMembers())
      dispatch(fetchBrokers())
      // Use the Redux thunk for most-viewed properties in the agents tab
      dispatch(fetchMostViewedPropertiesAgentThunk())
      dispatch(fetchReviewCounts())
    }

    // Admin totals (run for customers and agents views)
    if (activeTab === 'customer' || activeTab === 'both' || activeTab === 'agent') {
      dispatch(fetchAdminTotalMessages())
      dispatch(fetchAdminSavedItems())
    }

    dispatch(
      setMiniHeaderState({
        headerTitle: 'Overview',
        filter: filterValue,
        pathname,
        tab: activeTab,
      })
    )
  }, [dispatch, filterValue, activeTab])

  const allUsers = [...agents, ...customers]

  const getTotalSalesProperties = () => {
    if (!interestedProperties?.data) return 0
    return interestedProperties.data.reduce((total, item) => total + (item.count || 0), 0)
  }

  const getSwipeWithAction = () => {
    if (swipeActionData?.data?.totalCount) {
      return swipeActionData.data.totalCount
    }

    // Fallback to activities if swipe data not available
    if (!activities?.length) return 0
    return activities.filter(activity => activity.hasAction).length
  }

  const getSwipeWithoutAction = () => {
    if (swipeWithoutActionData?.data?.totalCount) {
      return swipeWithoutActionData.data.totalCount
    }

    // Fallback to activities if swipe data not available
    if (!activities?.length) return 0
    return activities.filter(activity => !activity.hasAction).length
  }

  const getMessageCountChartData = () => {
    if (messageCount?.data && Array.isArray(messageCount.data) && messageCount.data.length > 0) {
      return {
        messagesCount: messageCount.data[0].messagesCount,
      }
    }

    return null
  }

  const getAgentMessageCountChartData = () => {
    console.log('messageCountAnalytics:', messageCountAnalytics)
    // Support payload shape: { data: { total, trends: [{ _id: timestamp, count }] } }
    if (messageCountAnalytics?.data) {
      const payload = messageCountAnalytics.data

      // If payload contains trends array (new shape)
      if (Array.isArray(payload.trends) && payload.trends.length > 0) {
        // convert trends into hourlySessions/time-count arrays for MessageCount
        const hourlySessions = payload.trends.map(item => {
          // try to extract numeric hour from ISO timestamp (item._id)
          let hourStr = item._id
          try {
            const dt = new Date(item._id)
            if (!isNaN(dt.getTime())) {
              const hour = dt.getHours() // 0-23
              hourStr = `${hour}:00`
            }
          } catch (e) {
            // keep original _id if parsing fails
          }

          return {
            hour: hourStr,
            count: item.count || 0,
            sessions: item.count || 0,
          }
        })

        return {
          messagesCount: payload.total ?? payload.totalMessages ?? messageCountAnalytics.total ?? 0,
          hourlySessions,
        }
      }

      // legacy: payload is an array of objects or has first element with messagesCount
      if (Array.isArray(payload) && payload.length > 0) {
        return {
          messagesCount: payload[0].messagesCount || payload[0].count || 0,
        }
      }

      // fallback fields
      if (typeof payload.messagesCount === 'number' || typeof payload.total === 'number') {
        return {
          messagesCount: payload.messagesCount ?? payload.total ?? 0,
        }
      }
    }

    if (messageCountAnalytics?.messagesCount) {
      return { messagesCount: messageCountAnalytics.messagesCount }
    }

    if (messageCountAnalytics?.totalMessages) {
      return { messagesCount: messageCountAnalytics.totalMessages }
    }

    if (typeof messageCountAnalytics === 'number') {
      return { messagesCount: messageCountAnalytics }
    }

    // Fallback with some sample data for agent analytics
    const fallbackData = getMessageCountChartData()
    if (fallbackData) {
      return fallbackData
    }

    // If all else fails, provide a mock data structure for testing
    return {
      messagesCount: 1250,
    }
  }

  const getTotalMessageCount = () => {
    if (messageCount?.data && Array.isArray(messageCount.data) && messageCount.data.length > 0) {
      return messageCount.data[0].messagesCount || 0
    }
    return 0
  }

  const getMostViewedProperty = () => {
    if (!mostViewedProperties?.data || !mostViewedProperties.data.length) {
      return null
    }

    const sortedProperties = [...mostViewedProperties.data].sort((a, b) => b.view_count - a.view_count)
    const topProperty = sortedProperties[0]

    return {
      id: topProperty._id,
      title: topProperty.property?.property_title || 'Property',
      viewCount: topProperty.view_count,
      location: topProperty.property?.location || 'N/A',
      type: topProperty.property?.property_type || 'N/A',
      image: topProperty.property?.images?.[0] || '/assets/images/house.jpg',
      agentId: topProperty.agentId,
      interestedCount: topProperty.interested_count,
      dislikeCount: topProperty.dislike_count,
      interactionRatio: topProperty.interactionRatio,
    }
  }

  const getFilterClicksData = () => {
    // Use dynamic filter searches data from API
    if (filterSearches?.data && Array.isArray(filterSearches.data)) {
      return filterSearches.data.map(item => ({
        label: item.filter || item.filterName || item.label || 'Unknown',
        count: item.clicks || item.count || 0,
      }))
    }

    // Fallback to trendingAnalytics if available
    if (trendingAnalytics?.data?.filterClicks) {
      return trendingAnalytics.data.filterClicks
    }

    // Default fallback data
    return [
      { label: 'Bedroom', count: 50 },
      { label: 'Bathroom', count: 20 },
      { label: 'Pet', count: 100 },
      { label: 'Property Type', count: 20 },
      { label: 'Proximity', count: 10 },
      { label: 'Priority', count: 20 },
      { label: 'Location', count: 10 },
    ]
  }

  const getViewingsData = () => {
    return {
      daily: [
        { date: '2024-01-01', views: 45 },
        { date: '2024-01-02', views: 52 },
        { date: '2024-01-03', views: 38 },
        { date: '2024-01-04', views: 61 },
        { date: '2024-01-05', views: 47 },
      ],
    }
  }

  const getDeviceStats = () => {
    const androidUsers = allUsers.filter(user => user.device_type === 'android').length
    const iosUsers = allUsers.filter(user => user.device_type === 'ios').length
    return { android: androidUsers, ios: iosUsers }
  }

  const handleFilterChange = e => {
    const selectedValue = e.target.value
    setFilterValue(selectedValue)
    console.log('filterValue:', selectedValue)
  }

  const handleSeeMoreClick = e => {
    e.preventDefault()
    navigate('/properties')
  }

  const deviceStats = getDeviceStats()
  const mostViewedProperty = getMostViewedProperty()
  const viewingsData = getViewingsData()

  return (
    <>
      <MiniHeader title="Analytics" />
      <div className="flex min-h-screen">
        {/* Main content area - accounts for 250px sidebar */}
        <div className="flex-1 ml-[250px] min-h-screen">
          <div className="max-w-full px-6 py-6">
            {loading && <LoadingIndicator />}
            {error && <ErrorState error={error} />}
            {!loading && !error && (allUsers.length || properties.length) > 0 && (
              <div className="space-y-6">
                {/* Header Section with improved layout */}
                <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-6">
                  {/* Title Section */}
                  <div className="flex flex-col space-y-2">
                    <Typography variant="h4" className="text-gray-800 font-semibold">
                      Total Registered Users
                    </Typography>
                    <Typography variant="h2" className="text-3xl font-bold text-primary">
                      {allUsers.length.toLocaleString()}
                    </Typography>
                  </div>

                  {/* Controls Section */}
                  <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
                    {/* Filter Dropdown */}
                    <div className="flex items-center gap-2">
                      <Typography variant="body" className="text-gray-600 whitespace-nowrap">
                        Filter by:
                      </Typography>
                      <Select
                        value={filterValue}
                        options={filterOptions}
                        icon={<IoIosArrowDown />}
                        onChange={handleFilterChange}
                        className="min-w-[180px]"
                      />
                    </div>

                    {/* Tab Navigation */}
                    <div className="flex gap-1 p-1 bg-primary rounded-xl">
                      {tabs.map(tab => (
                        <Button
                          key={tab.id}
                          size="medium"
                          variant={activeTab === tab.id ? 'secondary' : null}
                          className={
                            activeTab === tab.id
                              ? 'bg-white text-gray-800 rounded-lg px-4 py-2 font-medium shadow-sm'
                              : 'text-white px-4 py-2 font-medium hover:bg-white/10 rounded-lg transition-colors'
                          }
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </Button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Stats Cards Section with responsive grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-8 gap-4">
                  <Card className="p-4 hover:shadow-md transition-shadow">
                    <Typography variant="h6" className="text-gray-600 font-semibold mb-1">
                      Total Downloads
                    </Typography>
                    <Typography variant="h5" className="text-xs font-bold text-gray-800">
                      {totalAppDownloads?.data?.total?.toLocaleString() ||
                        totalAppDownloads?.total?.toLocaleString() ||
                        '0'}
                    </Typography>
                  </Card>

                  {/* <Card className="p-4 hover:shadow-md transition-shadow">
                    <Typography variant="h5" className="text-gray-600 font-semibold mb-1">
                      Active Agents
                    </Typography>
                    <Typography variant="h4" className="text-sm font-bold text-green-600">
                      {agents.filter(agent => agent.status === 'active' || agent.status === 'ACTIVE').length.toLocaleString()}
                    </Typography>
                  </Card>

                  <Card className="p-4 hover:shadow-md transition-shadow">
                    <Typography variant="h5" className="text-gray-600 font-semibold mb-1">
                      Inactive Agents
                    </Typography>
                    <Typography variant="h4" className="text-sm font-bold text-red-600">
                      {agents.filter(agent => agent.status !== 'active' && agent.status !== 'ACTIVE').length.toLocaleString()}
                    </Typography>
                  </Card>

                  <Card className="p-4 hover:shadow-md transition-shadow">
                    <Typography variant="h5" className="text-gray-600 font-semibold mb-1">
                      Active Buyers
                    </Typography>
                    <Typography variant="h4" className="text-sm font-bold text-green-600">
                      {customers.filter(customer => customer.status === 'ACTIVE').length.toLocaleString()}
                    </Typography>
                  </Card>

                  <Card className="p-4 hover:shadow-md transition-shadow">
                    <Typography variant="h5" className="text-gray-600 font-semibold mb-1">
                      Inactive Buyers
                    </Typography>
                    <Typography variant="h4" className="text-sm font-bold text-red-600">
                      {customers.filter(customer => customer.status !== 'ACTIVE').length.toLocaleString()}
                    </Typography>
                  </Card> */}

                  <Card className="p-4 hover:shadow-md transition-shadow">
                    <Typography variant="h6" className="text-gray-600 font-semibold mb-1">
                      Total Active Users
                    </Typography>
                    <Typography variant="h5" className="text-sm font-bold text-gray-800">
                      {(
                        agents.filter(agent => agent.status === 'active' || agent.status === 'ACTIVE').length +
                        customers.filter(customer => customer.status === 'ACTIVE').length
                      ).toLocaleString()}
                    </Typography>
                  </Card>

                  <Card className="p-4 hover:shadow-md transition-shadow">
                    <Typography variant="h6" className="text-gray-600 font-semibold mb-1">
                      Total Inactive Users
                    </Typography>
                    <Typography variant="h5" className="text-sm font-bold text-gray-800">
                      {(
                        agents.filter(agent => agent.status !== 'active' && agent.status !== 'ACTIVE').length +
                        customers.filter(customer => customer.status !== 'ACTIVE').length
                      ).toLocaleString()}
                    </Typography>
                  </Card>

                  <Card className="p-4 hover:shadow-md transition-shadow">
                    <Typography variant="h6" className="text-gray-600 font-semibold mb-1">
                      Saved Items
                    </Typography>
                    <Typography variant="h5" className="text-sm font-bold text-gray-800">
                      {(adminSavedItems?.data?.total ?? adminSavedItems?.total ?? getTotalSalesProperties()).toLocaleString ? (adminSavedItems?.data?.total ?? adminSavedItems?.total ?? getTotalSalesProperties()).toLocaleString() : (adminSavedItems?.data?.total ?? adminSavedItems?.total ?? getTotalSalesProperties())}
                    </Typography>
                  </Card>

                  <Card className="p-4 hover:shadow-md transition-shadow">
                    <Typography variant="h6" className="text-gray-600 font-semibold mb-1">
                      Total Messages
                    </Typography>
                    <Typography variant="h5" className="text-sm font-bold text-gray-800">
                      {(adminTotalMessages?.data?.total ?? adminTotalMessages?.total ?? getTotalMessageCount()).toLocaleString ? (adminTotalMessages?.data?.total ?? adminTotalMessages?.total ?? getTotalMessageCount()).toLocaleString() : (adminTotalMessages?.data?.total ?? adminTotalMessages?.total ?? getTotalMessageCount())}
                    </Typography>
                  </Card>

                  <Card className="p-4 hover:shadow-md transition-shadow">
                    <Typography variant="h6" className="text-gray-600 font-semibold mb-1">
                      Swipe (with action)
                    </Typography>
                    <Typography variant="h5" className="text-sm font-bold text-gray-800">
                      {getSwipeWithAction().toLocaleString()}
                    </Typography>
                  </Card>

                  <Card className="p-4 hover:shadow-md transition-shadow">
                    <Typography variant="h6" className="text-gray-600 font-semibold mb-1">
                      Swipe (without action)
                    </Typography>
                    <Typography variant="h5" className="text-sm font-bold text-gray-800">
                      {getSwipeWithoutAction().toLocaleString()}
                    </Typography>
                  </Card>

                  <Card className="p-4 hover:shadow-md transition-shadow">
                    <div className="space-y-3">
                      <Typography variant="h6" className="text-gray-600 font-medium">
                        App Downloads
                      </Typography>
                      <div className="flex gap-2 items-center">
                        <ButtonCustom
                          variant="black"
                          size="small"
                          className="flex items-center justify-center p-1 cursor-pointer hover:bg-gray-100 transition-colors"
                        >
                          <div className="flex gap-1 items-center">
                            <RiAppleFill className="text-white text-xs" />
                            <Typography variant="body2" style={{ fontSize: '0.35rem' }}>
                              Apple ({deviceStats.ios})
                            </Typography>
                          </div>
                        </ButtonCustom>
                        <ButtonCustom
                          variant="black"
                          size="small"
                          className="flex items-center justify-center p-1 cursor-pointer hover:bg-gray-100 transition-colors"
                        >
                          <div className="flex gap-1 items-center">
                            <GooglePlayIcon size={12} />
                            <Typography variant="body2" style={{ fontSize: '0.35rem' }}>
                              Google ({deviceStats.android})
                            </Typography>
                          </div>
                        </ButtonCustom>
                      </div>
                    </div>
                  </Card>
                </div>

                {/* Dynamic Content based on active tab */}
                {activeTab === 'customer' && (
                  <div id={`${pathname}-${activeTab}-${filterValue}`} className="space-y-6">
                    {/* Filter-specific content */}
                    {filterValue === 'saved' && (
                      <div className="bg-white rounded-lg shadow-sm">
                        <TotalSaved
                          interestedData={interestedProperties}
                          likedData={likedProperties}
                          dislikedData={dislikedProperties}
                        />
                      </div>
                    )}

                    {filterValue === 'review' && (
                      <div className="space-y-6">
                        <div className="bg-white p-6 rounded-lg shadow-sm">
                          <ReviewChart data={trendingAnalytics?.data?.reviews} />
                        </div>
                        <div className="bg-white p-6 rounded-lg shadow-sm">
                          <SurveyReviewChart data={trendingAnalytics?.data?.surveys} />
                        </div>
                      </div>
                    )}

                    {filterValue === 'callCount' && (
                      <div className="bg-white p-6 rounded-lg shadow-sm">
                        <CallCount
                          data={callVolume}
                          showValue={callVolume?.totalCalls || '201'}
                          title="Call Volume"
                          tooltipLabel="Volume"
                          strokeColor="#6B8E23"
                          valueKey="count"
                          isAnalyticsOverview={true}
                          showTotalCount={true}
                        />
                      </div>
                    )}

                    {filterValue === 'messages' && (
                      <div className="bg-white p-6 rounded-lg shadow-sm">
                        <MessageCount
                          data={messageCountAnalytics}
                          title="Message Count Analytics"
                          tooltipLabel="Messages"
                          strokeColor="#6B8E23"
                          valueKey="messagesCount"
                          isAnalyticsOverview={true}
                          showTotalCount={true}
                        />
                      </div>
                    )}
                    {/* {filterValue === 'broker' && (
                      <div className="bg-white p-6 rounded-lg shadow-sm">
                        <div className="flex items-center justify-between mb-4">
                          <Typography variant="h6" className="text-gray-700 font-medium text-lg">
                            Brokers
                          </Typography>
                          <Typography variant="body" className="text-gray-500 text-sm">{(Array.isArray(brokers?.data) ? brokers.data.length : (brokers?.data?.total ?? brokers?.length) || 0)}</Typography>
                        </div>

                        <div className="space-y-3">
                          {brokers?.data && Array.isArray(brokers.data) && brokers.data.length > 0 ? (
                            brokers.data.slice(0, 10).map((broker, idx) => (
                              <div key={broker._id || idx} className="flex items-center justify-between gap-4">
                                <div className="flex items-center gap-4">
                                  <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-200 flex-shrink-0">
                                    <img src={broker.profile_photo || broker.avatar || '/assets/images/house.jpg'} alt={broker.full_name || broker.name || 'Broker'} className="w-full h-full object-cover" onError={e => { e.target.src = '/assets/images/house.jpg' }} />
                                  </div>
                                  <div>
                                    <Typography variant="body" className="font-medium text-gray-900 text-sm truncate">
                                      {broker.full_name || broker.fullName || broker.name || `Broker ${idx + 1}`}
                                    </Typography>
                                    <Typography variant="body" className="text-gray-500 text-xs">
                                      {broker.company || broker.organisation || broker.organization || 'Company'}
                                    </Typography>
                                  </div>
                                </div>

                                <div className="text-right">
                                  <Typography variant="body" className="text-gray-700 text-sm font-semibold">
                                    {broker.sales ? (broker.sales.toLocaleString ? broker.sales.toLocaleString() : broker.sales) : ''}
                                  </Typography>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="text-sm text-gray-500">No brokers available</div>
                          )}
                        </div>
                      </div>
                    )} */}
                    {/* Default 'all' view with comprehensive layout */}
                    {!['saved', 'review', 'callCount', 'messages'].includes(filterValue) && (
                      <div className="space-y-6">
                        {/* Top row with charts and most viewed property */}
                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                          <Card className="lg:col-span-4 mt-4">
                            <TotalSaved
                              interestedData={interestedProperties}
                              likedData={likedProperties}
                              dislikedData={dislikedProperties}
                            />
                          </Card>
                          <div className="lg:col-span-3">
                            <Card className="p-6 mt-4">
                              <div className="flex items-center justify-between mb-6">
                                <Typography variant="h6" className="text-gray-700 font-medium text-lg">
                                  Most viewed property
                                </Typography>
                                <button
                                  onClick={handleSeeMoreClick}
                                  className="text-cyan-500 hover:text-cyan-600 transition-colors focus:outline-none focus:ring-2 focus:ring-cyan-500/20 rounded text-sm whitespace-nowrap font-medium"
                                >
                                  See more
                                </button>
                              </div>

                              <div className="space-y-4">
                                {mostViewedProperties?.data && mostViewedProperties.data.length > 0 ? (
                                  [...mostViewedProperties.data]
                                    .sort((a, b) => b.view_count - a.view_count)
                                    .slice(0, 4)
                                    .map((property, index) => (
                                      <div key={property._id || index} className="flex items-center gap-4">
                                        <div className="w-12 h-12 bg-gray-200 rounded-lg overflow-hidden flex-shrink-0">
                                          <img
                                            src={property.property?.images?.[0] || '/assets/images/house.jpg'}
                                            alt={property.property?.property_title || 'Property'}
                                            className="w-full h-full object-cover"
                                            onError={e => {
                                              e.target.src = '/assets/images/house.jpg'
                                            }}
                                          />
                                        </div>

                                        {/* Property Details */}
                                        <div className="flex-1 min-w-0">
                                          <div className="flex justify-between items-start gap-4">
                                            <div className="min-w-0 flex-1">
                                              <Typography
                                                variant="h5"
                                                className="font-medium text-gray-900 text-base truncate leading-tight mb-1"
                                              >
                                                {property.property?.property_title || `Property ${index + 1}`}
                                              </Typography>
                                              <Typography variant="h5" className="text-gray-500 text-sm">
                                                {property.view_count || 0} Views
                                              </Typography>
                                            </div>

                                            <div className="text-right flex-shrink-0 min-w-0">
                                              <Typography
                                                variant="h5"
                                                className="text-gray-600 text-sm font-medium mb-1"
                                              >
                                                Agent
                                              </Typography>
                                              <Typography
                                                variant="h5"
                                                className="text-gray-500 text-sm truncate max-w-[100px]"
                                                title={
                                                  property.agentId &&
                                                    typeof property.agentId === 'object' &&
                                                    property.agentId.fullName
                                                    ? property.agentId.fullName
                                                    : property.agentId && typeof property.agentId === 'string'
                                                      ? property.agentId.slice(-8)
                                                      : 'Unknown Agent'
                                                }
                                              >
                                                {property.agentId &&
                                                  typeof property.agentId === 'object' &&
                                                  property.agentId.fullName
                                                  ? property.agentId.fullName
                                                  : property.agentId && typeof property.agentId === 'string'
                                                    ? property.agentId.slice(-8)
                                                    : 'Unknown Agent'}
                                              </Typography>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                ) : (
                                  <div className="space-y-4">
                                    {[
                                      { title: 'Erik Apartment...', views: 210, agent: 'Jirag Raj' },
                                      { title: 'Busha...', views: 110, agent: 'Jirag Raj' },
                                      { title: 'Busha...', views: 70, agent: 'Jirag Raj' },
                                      { title: 'Busha...', views: 70, agent: 'Jirag Raj' },
                                    ].map((property, index) => (
                                      <div key={index} className="flex items-center gap-4">
                                        <div className="w-12 h-12 bg-gray-200 rounded-lg overflow-hidden flex-shrink-0">
                                          <img
                                            src="/assets/images/house.jpg"
                                            alt={property.title}
                                            className="w-full h-full object-cover"
                                          />
                                        </div>

                                        {/* Property Details */}
                                        <div className="flex-1 min-w-0">
                                          <div className="flex justify-between items-start gap-4">
                                            <div className="min-w-0 flex-1">
                                              <Typography
                                                variant="body"
                                                className="font-medium text-gray-900 text-base truncate leading-tight mb-1"
                                              >
                                                {property.title}
                                              </Typography>
                                              <Typography variant="body" className="text-gray-500 text-sm">
                                                {property.views} Views
                                              </Typography>
                                            </div>

                                            <div className="text-right flex-shrink-0 min-w-0">
                                              <Typography
                                                variant="body"
                                                className="text-gray-600 text-sm font-medium mb-1"
                                              >
                                                Agent
                                              </Typography>
                                              <Typography
                                                variant="body"
                                                className="text-gray-500 text-sm truncate max-w-[100px]"
                                                title={property.agent}
                                              >
                                                {property.agent}
                                              </Typography>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </Card>
                          </div>

                          <Card className="lg:col-span-5 bg-white rounded-lg mt-4 shadow-sm">
                            <ViewingsBarCustom
                              data={hourlyPropertyViews}
                              color="#5ba474"
                              groupBy="hour"
                              viewType="hourly"
                              height={300}
                              showGrid={true}
                              barSize={40}
                              yAxisFormat="number"
                              showTitle={true}
                              emptyStateMessage="No hourly property views data available"
                            />
                          </Card>
                        </div>

                        {/* Bottom row with charts and filter table */}
                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                          <div className="lg:col-span-8">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                              <div className="bg-white p-4 rounded-lg shadow-sm">
                                <MessageCount
                                  data={messageCountAnalytics}
                                  title="Message Count"
                                  tooltipLabel="Messages"
                                  strokeColor="#6B8E23"
                                  valueKey="messagesCount"
                                  isAnalyticsOverview={true}
                                  showTotalCount={true}
                                />
                              </div>
                              <div className="bg-white p-4 rounded-lg shadow-sm">
                                <CallCount
                                  data={callVolume}
                                  showValue={callVolume?.totalCalls || '201'}
                                  title="Call Volume"
                                  showTitle={true}
                                  tooltipLabel="Volume"
                                  strokeColor="#6A5ACD"
                                  valueKey="count"
                                  isAnalyticsOverview={true}
                                  showTotalCount={true}
                                />
                              </div>
                              <div className="bg-white p-4 rounded-lg shadow-sm">
                                <RatingChart data={platformRatingStatistics} />
                              </div>
                              <div className="bg-white p-4 rounded-lg shadow-sm">
                                <ReviewChart data={platformRatingStatistics} />
                              </div>
                            </div>
                          </div>

                          {/* Filter clicks table (styled to match design) */}
                          <div className="lg:col-span-4">
                            <div className="h-full bg-white rounded-lg shadow-sm overflow-hidden">
                              {/* Header */}
                              <div className="px-4 py-3 bg-teal-500 text-white flex items-center justify-between">
                                <div className="text-sm font-semibold">Filter search</div>
                                <div className="text-sm font-semibold">Clicks</div>
                              </div>

                              {/* Rows */}
                              <div className="divide-y">
                                {getFilterClicksData().map((item, index) => (
                                  <div
                                    key={index}
                                    className={`px-4 py-3 flex items-center justify-between ${index % 2 === 1 ? 'bg-teal-50' : 'bg-white'}`}
                                  >
                                    <Typography variant="body" className="text-gray-700">
                                      {item.label}
                                    </Typography>
                                    <Typography variant="body" className="font-semibold text-gray-800">
                                      {item.count}
                                    </Typography>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* Agent Tab Content */}
                {activeTab === 'agent' && (
                  <div id={`${pathname}-${activeTab}-${filterValue}`} className="space-y-6">
                    {/* Broker/Company List View */}
                    {filterValue === 'broker' && (
                      <div className="w-2/5">
                        {' '}
                        {/* Changed from col-span-3/4 to actual grid classes */}
                        <div className="bg-white rounded-lg shadow-sm">
                          <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                              <colgroup>
                                <col style={{ width: '50%' }} />
                                <col style={{ width: '50%' }} />
                              </colgroup>
                              <thead>
                                <tr className="bg-teal-500 text-white rounded-t-lg">
                                  <th className="px-4 py-2 text-left rounded-tl-lg">
                                    <Typography variant="h6" className="font-medium text-lg">
                                      Broker
                                    </Typography>
                                  </th>
                                  <th className="px-4 py-2 text-right rounded-tr-lg pr-4">
                                    <Typography variant="h6" className="font-medium text-lg">
                                      Company
                                    </Typography>
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-gray-100">
                                {brokers?.data?.brokers &&
                                  Array.isArray(brokers.data.brokers) &&
                                  brokers.data.brokers.length > 0 ? (
                                  brokers.data.brokers.map((broker, idx) => (
                                    <tr key={broker._id || idx} className="hover:bg-gray-50">
                                      <td className="px-4 py-3 align-middle">
                                        <div className="flex items-center gap-4">
                                          <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-200 flex-shrink-0">
                                            <img
                                              src={
                                                broker.image ||
                                                broker.profile_photo ||
                                                broker.avatar ||
                                                '/assets/images/house.jpg'
                                              }
                                              alt={broker.full_name || broker.name || `Broker ${idx + 1}`}
                                              className="w-full h-full object-cover"
                                              onError={e => {
                                                e.target.src = '/assets/images/house.jpg'
                                              }}
                                            />
                                          </div>
                                          <div>
                                            <Typography variant="body" className="font-medium text-gray-900 text-base">
                                              {broker.full_name ||
                                                broker.fullName ||
                                                broker.name ||
                                                `Broker ${idx + 1}`}
                                            </Typography>
                                          </div>
                                        </div>
                                      </td>
                                      <td className="px-4 py-3 align-middle text-right pr-4">
                                        <Typography variant="body" className="text-gray-900 text-base truncate">
                                          {broker.companyDetails?.name || broker.company || 'N/A Company'}
                                        </Typography>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={2} className="px-4 py-8 text-center">
                                      <Typography variant="body" className="text-gray-500">
                                        No brokers available
                                      </Typography>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Default Agent Dashboard View */}
                    {filterValue !== 'broker' && (
                      <>
                        {/* First Row - 3 Chart Components */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                          {/* Total call volume */}
                          <Card className="p-6">
                            <CallCount
                              data={callVolume}
                              showValue={callVolume?.totalCalls || '201'}
                              title="Call Volume"
                              showTitle={true}
                              tooltipLabel="Volume"
                              strokeColor="#6B8E23"
                              valueKey="count"
                              isAnalyticsOverview={true}
                              showTotalCount={true}
                            />
                          </Card>

                          {/* Message Count */}
                          <Card className="p-6">
                            <MessageCount
                              data={messageCountAnalytics}
                              title="Message Count"
                              tooltipLabel="Messages"
                              strokeColor="#6B8E23"
                              valueKey="messagesCount"
                              isAnalyticsOverview={true}
                              showTotalCount={true}
                            />
                          </Card>

                          {/* Total sales/rental/sold */}
                          <Card className="p-6">
                            <TotalSales
                              data={salesTrends}
                              title="Total sales"
                              showLegend={true}
                              showValue={salesTrends?.totalSales || '500'}
                            />
                          </Card>
                        </div>

                        {/* Second Row - 3 Chart Components */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                          {/* Total number of bookings */}
                          <Card className="p-6">
                            <ViewingsBarCustom
                              data={bookings}
                              title="Total number of bookings"
                              showValue={bookings?.totalBookings || '112'}
                            />
                          </Card>

                          {/* Total number of rating */}
                          <Card className="p-6">
                            <RatingChart
                              data={ratings}
                              title="Total number of rating"
                              showValue={ratings?.totalRatings || '204'}
                            />
                          </Card>

                          {/* Total number of returns on commission */}
                          <Card className="p-6">
                            <div className="flex items-center justify-between mb-2">
                              <Typography variant="h6" className="text-gray-700 font-medium text-lg">
                                Total number of returns on commission
                              </Typography>
                            </div>

                            <div className="flex items-center gap-2 mb-6">
                              {/* <Typography variant="h4" className="text-md font-bold text-gray-900">
                            ${commissionReturns?.data?.total?.toLocaleString() || "446,004"}
                          </Typography> */}
                              <p className="text-md font-bold text-gray-800 mt-1">
                                ${commissionReturns?.data?.total?.toLocaleString() || '446,004'}
                              </p>
                              <span className="text-green-500 text-sm font-medium flex items-center">
                                {commissionReturns?.data?.avgPercentage || '+8.2%'} ↗
                              </span>
                            </div>

                            <div className="space-y-3">
                              <CommissionReturnsChart
                                data={commissionReturns}
                                title=""
                                showTitle={false}
                                showTotal={false}
                                color="#6c3260"
                                barSize={50}
                                height={220}
                              />
                            </div>
                          </Card>
                        </div>

                        {/* Third Row - 4 Columns */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                          {/* Top selling broker */}
                          <Card className="p-6">
                            <div className="flex items-center justify-between mb-6">
                              <Typography variant="h6" className="text-gray-700 font-medium text-lg">
                                Top selling broker
                              </Typography>
                            </div>

                            <div className="space-y-4">
                              {topBrokers?.data && topBrokers.data.length > 0 ? (
                                topBrokers.data.slice(0, 5).map((item, index) => {
                                  // support both legacy broker object and new { sales, agent } shape
                                  const brokerObj = item.agent || item.broker || item
                                  const sales = item.sales || item.saleCount || item.salesCount || brokerObj.sales || 0
                                  const profile =
                                    brokerObj.profile_photo ||
                                    brokerObj.profilePhoto ||
                                    brokerObj.avatar ||
                                    '/assets/images/house.jpg'
                                  const name =
                                    brokerObj.full_name || brokerObj.fullName || brokerObj.name || `Broker ${index + 1}`
                                  const company = brokerObj.company || 'Redhouse Group'

                                  return (
                                    <div
                                      key={(brokerObj && brokerObj._id) || index}
                                      className="flex items-center gap-4"
                                    >
                                      <div className="w-8 h-8 bg-gray-200 rounded-full overflow-hidden flex-shrink-0 flex items-center justify-center">
                                        <img
                                          src={profile}
                                          alt={name}
                                          className="w-full h-full object-cover"
                                          onError={e => {
                                            e.target.src = '/assets/images/house.jpg'
                                          }}
                                        />
                                      </div>

                                      <div className="flex-1 min-w-0">
                                        <Typography
                                          variant="body"
                                          className="font-medium text-gray-900 text-sm truncate"
                                        >
                                          {name}
                                        </Typography>
                                        <div className="flex items-center justify-between">
                                          <Typography variant="body" className="text-gray-500 text-xs">
                                            {company}
                                          </Typography>
                                          <Typography variant="body" className="text-gray-700 text-xs font-semibold">
                                            {sales.toLocaleString ? sales.toLocaleString() : sales}
                                          </Typography>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                })
                              ) : (
                                <div className="space-y-4">
                                  {[
                                    { name: 'Jirag Raj', company: 'Redhouse Group' },
                                    { name: 'Anslem Raj', company: 'Redhouse Group' },
                                    { name: 'Anslem Raj', company: 'Redhouse Group' },
                                    { name: 'Anslem Raj', company: 'Redhouse Group' },
                                    { name: 'Anslem Raj', company: 'Redhouse Group' },
                                  ].map((agent, index) => (
                                    <div key={index} className="flex items-center gap-4">
                                      <div className="w-8 h-8 bg-gray-200 rounded-full overflow-hidden flex-shrink-0 flex items-center justify-center">
                                        <img
                                          src="/assets/images/house.jpg"
                                          alt={agent.name}
                                          className="w-full h-full object-cover"
                                        />
                                      </div>

                                      <div className="flex-1 min-w-0">
                                        <Typography
                                          variant="body"
                                          className="font-medium text-gray-900 text-sm truncate"
                                        >
                                          {agent.name}
                                        </Typography>
                                        <Typography variant="body" className="text-gray-500 text-xs">
                                          {agent.company}
                                        </Typography>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </Card>

                          {/* Team Members */}
                          <Card className="p-6">
                            <div className="flex items-center justify-between mb-6">
                              <Typography variant="h6" className="text-gray-700 font-medium text-lg">
                                Team Members{' '}
                                <span className="text-gray-500 text-sm">
                                  {(teamMembers?.data?.total ?? teamMembers?.data?.length) || '13'}
                                </span>
                              </Typography>
                              <button
                                onClick={() => navigate('/users/agents')}
                                className="text-cyan-500 hover:text-cyan-600 transition-colors focus:outline-none focus:ring-2 focus:ring-cyan-500/20 rounded text-sm whitespace-nowrap font-medium"
                              >
                                See more
                              </button>
                            </div>

                            <div className="space-y-4">
                              {teamMembers?.data &&
                                (Array.isArray(teamMembers.data.members)
                                  ? teamMembers.data.members.length > 0
                                  : Array.isArray(teamMembers.data)
                                    ? teamMembers.data.length > 0
                                    : false) ? (
                                // support { data: { total, members: [...] } } or legacy { data: [...] }
                                (Array.isArray(teamMembers.data.members) ? teamMembers.data.members : teamMembers.data)
                                  .slice(0, 5)
                                  .map((member, index) => (
                                    <div key={member._id || index} className="flex items-center gap-4">
                                      <div className="w-8 h-8 bg-gray-200 rounded-full overflow-hidden flex-shrink-0 flex items-center justify-center">
                                        <img
                                          src={member.profile_photo || member.avatar || '/assets/images/house.jpg'}
                                          alt={member.full_name || member.fullName || `Team Member ${index + 1}`}
                                          className="w-full h-full object-cover"
                                          onError={e => {
                                            e.target.src = '/assets/images/house.jpg'
                                          }}
                                        />
                                      </div>

                                      <div className="flex-1 min-w-0">
                                        <div className="flex justify-between items-center">
                                          <div className="min-w-0 flex-1">
                                            <Typography
                                              variant="body"
                                              className="font-medium text-gray-900 text-sm truncate"
                                            >
                                              {member.full_name || member.fullName || `Team Member ${index + 1}`}
                                            </Typography>
                                            <div className="flex items-center gap-2">
                                              <span
                                                className={`inline-block w-2 h-2 rounded-full ${member.status === 'active' || member.status === 'ACTIVE'
                                                  ? 'bg-green-500'
                                                  : 'bg-gray-400'
                                                  }`}
                                              ></span>
                                              <Typography variant="body" className="text-gray-500 text-xs">
                                                {member.role || 'Sales Rep'}
                                              </Typography>
                                            </div>
                                          </div>
                                          <Typography variant="body" className="text-gray-500 text-xs">
                                            {member.joinedDate || member.joinedAt || 'joined today, 10:10 PM'}
                                          </Typography>
                                        </div>
                                      </div>
                                    </div>
                                  ))
                              ) : (
                                <div className="space-y-4">
                                  {[
                                    { name: 'Bolaji Jinadu', role: 'Sales Rep', status: 'active' },
                                    { name: 'Mark Jude', role: 'IT Support', status: 'active' },
                                    { name: 'Rashida Raia', role: 'Marketer', status: 'active' },
                                    { name: 'A.A Sule', role: 'Accountant', status: 'active' },
                                  ].map((agent, index) => (
                                    <div key={index} className="flex items-center gap-4">
                                      <div className="w-8 h-8 bg-gray-200 rounded-full overflow-hidden flex-shrink-0 flex items-center justify-center">
                                        <img
                                          src="/assets/images/house.jpg"
                                          alt={agent.name}
                                          className="w-full h-full object-cover"
                                        />
                                      </div>

                                      <div className="flex-1 min-w-0">
                                        <div className="flex justify-between items-center">
                                          <div className="min-w-0 flex-1">
                                            <Typography
                                              variant="body"
                                              className="font-medium text-gray-900 text-sm truncate"
                                            >
                                              {agent.name}
                                            </Typography>
                                            <div className="flex items-center gap-2">
                                              <span
                                                className={`inline-block w-2 h-2 rounded-full ${agent.status === 'active' ? 'bg-green-500' : 'bg-gray-400'
                                                  }`}
                                              ></span>
                                              <Typography variant="body" className="text-gray-500 text-xs">
                                                {agent.role}
                                              </Typography>
                                            </div>
                                          </div>
                                          <Typography variant="body" className="text-gray-500 text-xs">
                                            joined today, 10:10 PM
                                          </Typography>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </Card>

                          {/* Most viewed properties */}
                          <Card className="p-6">
                            <div className="flex items-center justify-between mb-6">
                              <Typography variant="h6" className="text-gray-700 font-medium text-lg">
                                Most viewed properties
                              </Typography>
                            </div>

                            <div className="space-y-4">
                              {(() => {
                                // normalize thunk payload which may be { data: [...] } or an array
                                const agentViewedList = Array.isArray(mostViewedPropertiesAgent)
                                  ? mostViewedPropertiesAgent
                                  : mostViewedPropertiesAgent && Array.isArray(mostViewedPropertiesAgent.data)
                                    ? mostViewedPropertiesAgent.data
                                    : []

                                if (agentViewedList && agentViewedList.length > 0) {
                                  return agentViewedList
                                    .slice()
                                    .sort((a, b) => (b.view_count || 0) - (a.view_count || 0))
                                    .slice(0, 5)
                                    .map((property, index) => (
                                      <div key={property._id || index} className="flex items-center gap-4">
                                        <div className="w-12 h-12 bg-gray-200 rounded-lg overflow-hidden flex-shrink-0">
                                          <img
                                            src={property.property?.images?.[0] || '/assets/images/house.jpg'}
                                            alt={property.property?.property_title || 'Property'}
                                            className="w-full h-full object-cover"
                                            onError={e => {
                                              e.target.src = '/assets/images/house.jpg'
                                            }}
                                          />
                                        </div>

                                        <div className="flex-1 min-w-0">
                                          <Typography
                                            variant="body"
                                            className="font-medium text-gray-900 text-sm truncate mb-1"
                                          >
                                            {property.property?.property_title || `Property ${index + 1}`}
                                          </Typography>
                                          <Typography variant="body" className="text-gray-500 text-xs">
                                            {property.view_count || 0} views
                                          </Typography>
                                        </div>
                                      </div>
                                    ))
                                }

                                return (
                                  <div className="space-y-4">
                                    {[
                                      { title: 'Erik Apartment...', views: '120 views' },
                                      { title: 'Down crest', views: '150 views' },
                                      { title: 'Starlight', views: '140 views' },
                                      { title: 'Sharjah Residence', views: '180 views' },
                                      { title: 'Twin waters', views: '149 views' },
                                    ].map((property, index) => (
                                      <div key={index} className="flex items-center gap-4">
                                        <div className="w-12 h-12 bg-gray-200 rounded-lg overflow-hidden flex-shrink-0">
                                          <img
                                            src="/assets/images/house.jpg"
                                            alt={property.title}
                                            className="w-full h-full object-cover"
                                          />
                                        </div>

                                        <div className="flex-1 min-w-0">
                                          <Typography
                                            variant="body"
                                            className="font-medium text-gray-900 text-sm truncate mb-1"
                                          >
                                            {property.title}
                                          </Typography>
                                          <Typography variant="body" className="text-gray-500 text-xs">
                                            {property.views}
                                          </Typography>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )
                              })()}
                            </div>
                          </Card>

                          {/* Total number of reviews */}
                          <Card className="p-6">
                            {/* <div className="flex items-center justify-between mb-6">
                        < Typography variant="h6" className="text-gray-700 font-medium text-lg">
                            Total number of review
                          </Typography>
                        </div> */}

                            {/* <div className="text-center mb-6">
                          <Typography variant="h2" className="text-3xl font-bold text-gray-900 mb-2">
                            {reviewCounts?.totalReviews || "0"}
                          </Typography>
                        </div> */}

                            <div className="space-y-3">
                              <ReviewChart data={platformRatingStatistics} />
                            </div>
                          </Card>
                        </div>
                      </>
                    )}
                  </div>
                )}

                {/* Toast Modal */}
                {showToast && (
                  <Backdrop isOpen={showToast} onClose={() => setShowToast(false)}>
                    <Card className="p-8 max-w-sm mx-auto">
                      <div className="text-center space-y-4">
                        <div className="flex justify-center">
                          <MdOutlineVerified className="text-primary text-5xl" />
                        </div>
                        <Typography variant="h5" className="font-semibold">
                          Download Complete
                        </Typography>
                        <Button size="medium" onClick={() => setShowToast(false)} className="w-full">
                          Done
                        </Button>
                      </div>
                    </Card>
                  </Backdrop>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Overview
